import type { Address } from '~~/types/commercetools';
import type { AddressType } from '~~/types/AddressType';
import { ADDRESS_FIELD_MAX_LENGTHS } from '~~/constants/addressFields';
import { getTypedKeys } from '~~/helpers/dataStructure/objectOperationsTyped';

export const truncateAddressFields = (
  address: Partial<Address>,
  addressType: AddressType,
): Partial<Address> => {

  const maxLengths = ADDRESS_FIELD_MAX_LENGTHS[addressType];
  const truncatedAddress: Partial<Address> = { ...address };

  for (const field of getTypedKeys(maxLengths)) {

    const value = truncatedAddress[field];

    if (typeof value === 'string' && value.length > maxLengths[field]) {

      truncatedAddress[field] = value.slice(0, maxLengths[field]);

    }

  }

  return truncatedAddress;

};
